/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { EDP_IDR } from '@hbrisk/sp3-risk-model-support/edps/edps.js';
import { selectResponsesForEdp } from '#selectors/ui/form/model.js';
import DerivedFromSelectMenu from './DerivedFromSelectMenu.jsx';

const mapStateToProps = (state, ownProps) => {
  const responses = selectResponsesForEdp(ownProps.form)(state, { edpKey: EDP_IDR });
  return {
    responses,
  };
};

export default connect(mapStateToProps)(DerivedFromSelectMenu);
